import moment from "moment";

// Constrained to locales actually imported via `moment/dist/locale/*`.
// A wider `string` would let callers pass a typo'd locale that silently
// falls back to moment's global locale.
export type SupportedLocale = "nb" | "en";

export const displayDate = (value: string, locale?: SupportedLocale | null): string => {
  const date = locale ? moment(value).locale(locale) : moment(value);
  return date.format("DD MMM YYYY");
};